(function () {
    function mainCode($) {
        $(document).on('Searchanise.ResultsUpdated', function() {
            $('.snize-product .snize-item-image').each(function() {
                if ($(this).attr('src').indexOf('_large') !== -1) {
                    $(this).attr('src', $(this).attr('src').replace('_large', ''));
                }
            });

            // $('span.money').each(function(idx, span){
            //     price = $(span).text();
            //     if (typeof shopifyCurrencyFormat !== 'undefined') {
            //         price = shopifyCurrencyFormat.replace(/{[^}]+}}/g, price.replace('$', ''));
            //         $(span).text(price);
            //     }
            // });
        });
    }
    function waitUntilDefined() {
        if (typeof Searchanise !== "undefined" && typeof Searchanise.$ !== "undefined") {
            mainCode(Searchanise.$);
        } else {
            setTimeout(waitUntilDefined, 400);
        }
    }
    waitUntilDefined();
     
    $(document).on("Searchanise.ResultsUpdated", function () {
      if( $('.snize-no-products-found').length == 0){
       // console.log("Searchniserr appp.. ");
            $('.custom_col_filter').insertBefore('ul.snize-search-results-content.clearfix').css('display','flex');
      }
        if( $('.snize-no-products-found').length == 0 && $('#snize_filters_block_snize_facet12').length != 0 ) {
            $(".page_search-results-page .snize.snize-search-results").removeClass('no_products_search_results');
            $(".searchanise-recommendations").addClass('hide');
        }else{
            // $(".page_search-results-page .snize.snize-search-results").addClass('no_products_search_results');
            $(".snize-popular-suggestions-text").remove();
            $(".continue_shopping").remove();
            // $('<div class="snize-popular-suggestions-text main_wrapper_suggestions">Check out some of these popular searches: <div class="snize-popular-suggestions-container"><a class="snize-no-products-found-link" href="/pages/search-results-page?q=gucci%20sunglasses" data-no-instant="true">gucci sunglasses</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=tom%20ford" data-no-instant="true">tom ford</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=tom%20ford%20sunglasses" data-no-instant="true">tom ford sunglasses</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=round%20glasses" data-no-instant="true">round glasses</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=ray%20ban%20sunglasses" data-no-instant="true">ray ban sunglasses</a></div></div>').insertBefore(".page_search-results-page ul.snize-search-results-content");
            // $('<a class="continue_shopping" href="/collections/all">Continue Shopping</a>').insertAfter(".page_search-results-page .snize-recommendation-results");
            // $(".searchanise-recommendations").removeClass('hide');
        }
        if($(".snize-no-products-found").length > 0 ){
            $(".page_search-results-page .snize.snize-search-results").addClass('no_products_search_results');
            $('<div class="snize-popular-suggestions-text main_wrapper_suggestions">Check out some of these popular searches: <div class="snize-popular-suggestions-container"><a class="snize-no-products-found-link" href="/pages/search-results-page?q=gucci%20sunglasses" data-no-instant="true">gucci sunglasses</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=tom%20ford" data-no-instant="true">tom ford</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=tom%20ford%20sunglasses" data-no-instant="true">tom ford sunglasses</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=round%20glasses" data-no-instant="true">round glasses</a><a class="snize-no-products-found-link" href="/pages/search-results-page?q=ray%20ban%20sunglasses" data-no-instant="true">ray ban sunglasses</a></div></div>').insertBefore(".page_search-results-page ul.snize-search-results-content");
            $('<a class="continue_shopping" href="/collections/all">Continue Shopping</a>').insertAfter(".page_search-results-page .snize-recommendation-results");
            $(".searchanise-recommendations").removeClass('hide');
        }
      if(($("body").hasClass("ray-ban-new-product-template") == false) && ($("body").hasClass("miu-miu-new-product-template") == false) && ($("body").hasClass("ferrari-scuderia-glasses") == false ) && ($("body").hasClass("ferrari-scuderia-sunglasses") == false )){
        $(".collection-page-searchanise-collection-template .snize-search-results-content li.snize-product-tag-vto").each(function(){
           var curr = $(this).find(".snize-view-link .snize-thumbnail-wrapper");
         // alert("length---- "+$(this).find(".snize-view-link .snize-tryon-button-as-text").length);
          if($(this).find(".snize-view-link .snize-tryon-button-as-text").length <=0 ){
          $('<span class="snize-tryon-button-as-text" style="top: 210px;">VIRTUAL TRY ON</span>').insertAfter($(curr));
        }
            // var link = $(this).find(".snize-view-link").attr("href").replace(/\?variant=\d+/g, '');
            // var geturl = link+'?view=vtoverify';
            // var curr = $(this).find(".snize-view-link")  
            // $.ajax({
            //     url:geturl,
            //     type:'GET',
            //     dataType:'html',
            //     cache: false,
            //     async : false,
                
            // })
            // .done(function(data) {
            //     $(data).insertAfter($(curr));
            //    // console.log(data);
            // })
            // .fail(function(data) {})
            // .always(function(data) {});  
        });
      }else{
         $(".collection-page-searchanise-collection-template .snize-search-results-content li.snize-product-tag-vto").each(function(){
             var curr = $(this).find(".snize-view-link");
            $('<span data-avail="true" class="snize-tryon-button custom-jtpl-try-on-rayban custom" style="top: 210px;display:none;">VIRTUAL TRY ON</span>').insertAfter($(curr));
         });
      }
        


     
  setTimeout(function(){
     if($(".snize-banner").length > 0){
      $(".snize-banner").addClass("snize-product");
    }
    //Quiz Template
     if($("body").hasClass("template-collection") == true && $("body").hasClass("take-a-look-what-we-found-for-you") == true ){
       //snize-product-7928856969387
       console.log("take-a-look-what-we-found-for-you");
       var url = window.location.href;

       var queryParamsArr = url.split("?");
       var urlParams = new URLSearchParams(queryParamsArr[1]);
        var material = urlParams.get('rb_filter_metafield_ff24ea4b9c38b859c7fef9d89b807549');
      // material = material.toLowerCase().trim();
      // material = material.trim();
       console.log(material);
        var color = urlParams.get('rb_snize_facet16');
       // color = color.toLowerCase().trim();
        // color = color.trim();
             console.log(color);
        var size = urlParams.get('rb_snize_facet15');
       // size = size.toLowerCase().trim();
       
             console.log(size);
       var shape = urlParams.get('rb_snize_facet2');
      //  shape = shape.toLowerCase().trim();
      // shape = shape.trim();
             console.log(shape);  
       if(url.indexOf("rb_product_type=Glasses")> -1){
         //show me optical only
         var main_ajax_url = "/collections/optical-only-for-quiz-new?view=ajax-searchnise";
       }else{//show me both glasses & sunglasses.
           var main_ajax_url = "/collections/show-both-for-quiz-new?view=ajax-searchnise";       
       }
        $.ajax({
                  url: main_ajax_url,
                  type:'GET',
                   async: false,
                    cache: false,
                  dataType:'html' 
              })
              .done(function(data) {
               // console.log(data);
                var new_product_id=$(".snize-product").attr("product-id");
               // console.log("product id : "+ new_product_id);
                if(new_product_id =="7928856969387" || new_product_id=="7818365075627" ){
               // var new_grids = $(data).find("ul.snize-search-results-content").html(); 
               //  console.log("new grid data"+ new_grids);
               //    $("ul.snize-search-results-content").prepend(new_grids);
                }else{
                  var new_grids = $(data).find("ul.snize-search-results-content").html(); 
                $("ul.snize-search-results-content").prepend(new_grids);                  
                var count_to_show = 0;
                $("ul.snize-search-results-content li.snize-fixed-jtpl").each(function(index) {
                  var $thisLi = $(this);
                  //var tags = $(this).attr('data-tags').split(',').map(tag => tag.trim());
                  var tags = $(this).attr('metafield-data-tags').split(',').map(tag => tag.trim());
                  console.log(tags);
                     var attrNew = $(this).attr('metafield-data-tags');
                console.log("attrNew"+tags);
                 if (typeof attrNew !== 'undefined' && attrNew !== false){
                 console.log(shape+"==="+$.inArray(shape, tags)+"====="+color+"==="+$.inArray(color, tags)+"======="+material+"==="+$.inArray(material, tags));
                   if (($.inArray(shape,tags) !== -1 && $.inArray(material,tags) !== -1) && $.inArray(color,tags) !== -1) {
                     console.log("under if");
                     if(count_to_show < 6){
                       $thisLi.show()
                       count_to_show = count_to_show +1;
                       console.log("count --> "+ count_to_show);
                      console.log(index+"Innnnn");
                      }else{
                       $thisLi.hide();
                     }
                    }else{
                    // console.log(index+"Hide");
                     $thisLi.hide();
                    }

                  }

                });
                }
               })
                .fail(function(data) {})
                .always(function(data) {}); 
       

     }
    //end template
    
     if($("body").hasClass("collection-dior") == true || $("body").hasClass("collection-fendi") == true || $("body").hasClass("collection-tag-heuer") == true){
       $('.cstmResCount').remove();
       var totalResCount = '';
       var totalResCount = $('.snize-main-panel-collection-results-found b').html();
       totalResCount ='<div class="cstmResCount" style="display:block!important;">'+ totalResCount + ' Items</div>';
          $(totalResCount).insertAfter(".snize-main-panel-collection-results-found");
          var linkMain = window.location.href;
       if(linkMain.indexOf("?")> -1){
        var urlArr = linkMain.split("?");
         var geturl = urlArr[0]+'?view=fendi-dior-collection';
       }else{
         var geturl = linkMain+'?view=fendi-dior-collection';
       }
          
                        console.log(geturl);
                 $.ajax({
                            url:geturl,
                            type:'GET',
                             async: false,
                              cache: false,
                            dataType:'html' 
                        })
                        .done(function(data) {
                          //console.log(data);
                               
                           $(".snize-search-results-content li.snize-product").each(function(){
                              
                              var $this = $(this);
                              // if($this.find(".snize-title-jtpl").length == 0){
                                  var link = $(this).find(".snize-view-link").attr("href");
                                 var linkArr = link.split("/");
                                var handle = linkArr[linkArr.length -1];
                                var curr = $(this).find(".snize-title") ;
                               $this.find(".snize-title-jtpl").html('');
                              $this.find(".snize-title").addClass("snize-title-jtpl").html("").removeClass("snize-title");
                                var prd_data = $(data).closest("#"+handle).html();
                              $this.find(".snize-title-jtpl").append(prd_data);
                              // }
                           });
                        })
                        .fail(function(data) {})
                        .always(function(data) {});  
/*
       
            $(".snize-search-results-content li.snize-product").each(function(){
               var $this = $(this);
           //   console.log("happy.."+$this.find(".snize-title-jtpl").length);
              if($this.find(".snize-title-jtpl").length == 0){
              
              var link = $(this).find(".snize-view-link").attr("href").replace(/\?variant=\d+/g, '');
                        var geturl = link+'?view=fendi-dior-layout';
                        var curr = $(this).find(".snize-title") ;
                      $.ajax({
                            url:geturl,
                            type:'GET',
                             async: false,
                              cache: false,
                            dataType:'html' 
                        })
                        .done(function(data) {
                         // console.log(data);
                           $this.find(".snize-title-jtpl").html('');
                          $this.find(".snize-title").addClass("snize-title-jtpl").html("").removeClass("snize-title");
                          $this.find(".snize-title-jtpl").append(data);
                        })
                        .fail(function(data) {})
                        .always(function(data) {});  
              }
           });
          */
          }
  },100);
     
  
      
        setTimeout(function(){
         
            if($('.snize-filter-button.snize-clear-all-button').length == 0 ){
                $('.custom_col_filter .filter_items').removeClass('active'); 
                var brand_name = $(".collection_page_title h1").text();
                var remove_space = $.trim(brand_name);
                var main_text = $(".snize-no-products-found-text").text().trim();
                var final_data = main_text.replaceAll("[search_string]",remove_space);
                $(".snize-no-products-found-text span").text(final_data);
            }
            $(".snize-main-panel-mobile-filters a").click(function(){
                $(".snize-product-filters-header").hide();
                $(".snize-product-filter-container").hide();
                $("div#snize_filters_block_header").show();
                $("div#snize_filters_block").show();
                console.log("Filter click====");
                
            });
        },100);

        if (window.location.href.indexOf("sales_amount") > -1) {
            $('.sort_filter').addClass('active');
        }
        else{
            $('.sort_filter').removeClass('active');
        }
    });


    $(document).on("click",".snize-tryon-button",function(e){
      if($("body").hasClass("ray-ban-new-product-template")){
         e.preventDefault();
       var link = $(this).parents(".snize-product").find(".snize-view-link").attr("href").replace(/\?variant=\d+/g, '');
          window.location.href = link;
      }else{
        var barcode = $(this).attr("data-barcode");
        $('.colcode').attr('data-barcode',barcode);    
        $.cookie('col_barcode', barcode);  
        $("#hw__virtual_try_on_open_modal").trigger("click");
      }
      
     
        
    });
})();


document.addEventListener("Searchanise.Loaded", function () {
    (function ($) {
       
      
        function snizeAppendUnit(productEl) {
            var productData = productEl.data("snize_item_data");
             var productHandle = Searchanise.ExtractProductHandle(productData.link);

            $.get("/products/" + productHandle + ".xml").done(function (product_data) {
            if ($(product_data).find("variants").length) {
              var variantEl = $(product_data).find("variants").find("variant").first();
              var price = Searchanise.GetWidgets().formatPrice(variantEl.find("price").text());
             // $(".snize-title").append("<span class='combination-name'>Combination name</span>");
              $(".snize-price-list .snize-price", productEl).html(price);
              if (variantEl.find("compare-at-price").length) {
               if($.trim(variantEl.find("compare-at-price").text()) != ''){
                 var compareAt = Searchanise.GetWidgets().formatPrice(variantEl.find("compare-at-price").text());
                 $(".snize-price-list .snize-discounted-price", productEl).html(compareAt);
                }
              }
            }
            });
        }

        $(document).on("Searchanise.ResultsUpdated", function () {
            if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== "EUR") {
                // return;
            }
         
            $(".snize-search-results .snize-product").each(function (data) {
                snizeAppendUnit($(this));
            });
        });

        $(document).on("Searchanise.AutocompleteUpdated", function () {
            if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== "EUR") {
                // return;
            }
            $(".snize-ac-results .snize-product").each(function () {
                snizeAppendUnit($(this));
            });
        });

        $(document).on("Searchanise.RecommendationUpdated", function () {
            if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== "EUR") {
                // return;
            }
            $(".searchanise-recommendations .snize-product").each(function () {
                snizeAppendUnit($(this));
            });
        });
        document.addEventListener("DOMContentLoaded", function () {

           
        
            $('.snize-main-panel-dropdown-content li').each(function(){
                var sorting = $(this).find('a').text();
                $(this).find('a').attr('value',sorting);
            })
            if( $('.snize-no-products-found').length == 0) {
        //   console.log("Searchniserr2222222222load appp..");
                $('.custom_col_filter').insertBefore('ul.snize-search-results-content.clearfix').css('display','flex');
            }
            var brand_name = $(".collection_page_title h1").text();
            var remove_space = $.trim(brand_name);
            var main_text = $(".snize-no-products-found-text").text().trim();
            var final_data = main_text.replaceAll("[search_string]",remove_space);
            $(".snize-no-products-found-text span").text(final_data);
            $(".snize-main-panel-mobile-filters a").click(function(){
                $(".snize-product-filters-header").hide();
                $(".snize-product-filter-container").hide();
                $("div#snize_filters_block_header").show();
                $("div#snize_filters_block").show();
            });
        })
    })(window.Searchanise.$);
});
